enum PciDashboardProviderStatusEnum {
  Unknown = "Unknown",
  Terminated = "Terminated",
  Targeted = "Targeted",
  Excluded = "Excluded",
  Standard = "Standard",
}

export { PciDashboardProviderStatusEnum };
